import { apiClient } from './apiClient';

const base = '/api/sessions';

export const sessionService = {
  // Get sessions for a user
  list: userId => apiClient.get(`${base}/${userId}`),

  // Create a new session
  create: sessionData => apiClient.post(base, sessionData),

  // Update an existing session
  update: (sessionId, sessionData) => apiClient.put(`${base}/${sessionId}`, sessionData),

  // Delete a session
  delete: sessionId => apiClient.del(`${base}/${sessionId}`),

  // Get session by ID
  get: sessionId => apiClient.get(`${base}/${sessionId}`),
};

export default sessionService;
